/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MtBillingType {
    MONTHLY = 'MONTHLY',
    PER_WORD = 'PER_WORD',
    FREE_TRIAL = 'FREE_TRIAL',
}